<div class="heroBanner bgPrimary">
    <div class="container">
        <h1 class="colorWhite text-center">Explore Crosswind Events</h1>
    </div>
    
</div>

<div class="bgWhite py-80">
    <div class="container">
        <ng-container  *ngFor="let ele of getEventArray; let i = index">
            <!-- <div class="audiorowPart" *ngIf="i < 3 || ele.isRecuuring" style="background-color: #f78e41">
                <div class="col-12 col-md-11 col-lg-11 px-0 d-flex flex-wrap">
                    <div class="audioImg"><img src="{{apiUrl}}/{{ele?.profile}}" class="img-fluid" /></div> 
                                            <div class="audioDetails">
                        <h3 class="eventCustomHeading">{{ele.eventHeading}}</h3>
                        <p class="colorWhite">{{ele.eventDescriptionl}}</p>
                        <p class="colorWhite"><b>Location :</b> {{ ele.eventPlace }}</p>
                        <p class="colorWhite" *ngIf="!ele.isRecuuring"><b>Event Time :</b> {{ convertToLocalDate(ele.eventTime) | date:'MMM dd, yyyy hh:mm a' }}</p>
                        <p class="colorWhite" *ngIf="ele.isRecuuring" ><b>Event Time :</b> {{ convertToLocalDate(ele.eventTime) | date:'hh:mm a' }}</p>
                        <p class="colorWhite"><b>Speaker :</b> {{ ele.firstname }} {{ ele.lastName }}</p>
                        <p class="colorWhite" *ngIf="ele.isRecuuring"><b>{{ele.occurrence}}</b></p>
                    </div>
                </div>
            </div> -->

            <div class="recentEvemtPart mb-3 pb-3" *ngIf="i < 3 || ele.isRecuuring" >
                <div class="row">
                    <div class="col-12 col-md-3 col-lg-2 datepart">
                        <ng-container *ngIf="!ele.isRecuuring">
                            <div class="month">{{ convertToLocalDate(ele.eventTime) | date:'MMM' }}</div>
                            <div class="date">{{ convertToLocalDate(ele.eventTime) | date:'dd' }}</div>
                        </ng-container>
                        <ng-container *ngIf="ele.isRecuuring">
                            <div class="month">{{ele.occurrence}}</div>
                            <!-- <div class="date">{{ convertToLocalDate(ele.eventTime) | date:'dd' }}</div> -->
                        </ng-container>
                        
                     
                    </div>
                    <div class="col-12 col-md-9 col-lg-10 detailspart">
                        <h3>{{ele.eventHeading}}</h3>
                        <!-- <p class="colorWhite">{{ele.eventDescriptionl}}</p> -->
                        <div class="row">
                            <div class="col-3 col-md-2 fontBlk">Time:</div>
                            <div class="col-9 col-md-10 fontBlk"><strong>{{ convertToLocalDate(ele.eventTime) | date:'hh:mm a' }}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-3 col-md-2 fontBlk">Location:</div>
                            <div class="col-9 col-md-10 fontBlk"><strong>{{ ele.eventPlace }}</strong></div>
                        </div>
                        <!-- <a href="#" class="linkDark">View More</a> -->
                    </div>
                </div>
            </div>
    </ng-container>
    <pagination-controls
    *ngIf="getEventArray.length != 0" 
    (pageChange)="paginate($event)" 
class="float-right"
></pagination-controls>
        <!-- <div class="text-center mt-5"><button type="button" class="btn btnPrimary">Load More</button></div> -->
    </div>
</div>
